import _ from 'lodash';
import createjs from 'createjs-collection';

import * as fJS from './../cjsRoot/fJS';
import { cjsSelect } from './cjsSelect';
import { cjsEffects } from './../cjsObjects/cjsEffects';

var blockMove = false;

export class cjsMemo extends cjsSelect {
  _pairedNumber;

  constructor(obj) {
    super(obj);
  }

  create() {
    if (typeof this.otherProperty.registrationPoint !== 'object') this.otherProperty.registrationPoint = {};
    this.otherProperty.registrationPoint.x = this.pos.width / 2;
    this.otherProperty.registrationPoint.y = this.pos.height / 2;

    super.create();

    this.check.toVisible = this.check.visible = true;

    this.check._effect =
      typeof this.otherProperty.pair === 'object' &&
      typeof this.otherProperty.pair.hide === 'object' &&
      typeof this.otherProperty.pair.hide.effect === 'string' &&
      typeof cjsEffects[this.otherProperty.pair.hide.effect.toLowerCase()] === 'function'
        ? this.otherProperty.pair.hide.effect.toLowerCase()
        : this._stage.defConfig.pair.hide.effect;

    this.check._speed =
      typeof this.otherProperty.pair === 'object' &&
      typeof this.otherProperty.pair.hide === 'object' &&
      fJS.isNumeric(this.otherProperty.pair.hide.speed) === true
        ? this.otherProperty.pair.hide.speed
        : this._stage.defConfig.pair.hide.speed;

    this.check._waitStart =
      typeof this.otherProperty.pair === 'object' &&
      typeof this.otherProperty.pair.hide === 'object' &&
      fJS.isNumeric(this.otherProperty.pair.hide.wait) === true
        ? this.otherProperty.pair.hide.wait
        : this._stage.defConfig.pair.hide.wait;

    this.check._autoHide =
      typeof this.otherProperty.pair === 'object' &&
      typeof this.otherProperty.pair.hide === 'object' &&
      typeof this.otherProperty.pair.hide.removeCorrect === 'boolean'
        ? this.otherProperty.pair.hide.removeCorrect
        : this._stage.defConfig.pair.hide.removeCorrect;
  }

  setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules) {
    super.setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules);

    this._pairedNumber =
      typeof this.otherProperty.pair === 'object' && fJS.isNumeric(this.otherProperty.pair.pairedNumber) === true
        ? this.otherProperty.pair.pairedNumber
        : this._stage.defConfig.pair.pairedNumber;
  }

  stageMouseClick(e, data) {
    let engine = data.engine,
      stage = data.cjsStage;
    console.log(engine.id + ' CLICK ' + blockMove);
    stage.resetCheckStatus();
    if (engine.block === true || blockMove === true) {
      e.stopPropagation();
      return false;
    }
    engine.check.wait = 0;
    engine.check._stage = stage;
    if (engine.check.visible === false) {
      engine.check.visible = true;
      e.stopPropagation();
      return false;
    }

    let good = 0,
      bad = 0;
    for (let i in stage.groups[engine.idGroup].items) {
      if (
        stage.groups[engine.idGroup].items[i].check.visible === false &&
        stage.groups[engine.idGroup].items[i].block === false &&
        engine.id === stage.groups[engine.idGroup].items[i].id
      ) {
        good++;
      }
      if (
        stage.groups[engine.idGroup].items[i].check.visible === false &&
        stage.groups[engine.idGroup].items[i].block === false
      ) {
        bad++;
      }
    }

    if (good === engine.pairedNumber - 1 && bad < engine.pairedNumber) {
      engine.check.visible = false;
      engine.isCorrect = true;
      engine.time = new Date();
      engine.toVisible = false;
      engine.speed = engine.check.speed;
      engine.wait = engine.check.waitStart;
      engine.effect = 'hide';
      for (let i in stage.groups[engine.idGroup].items) {
        if (
          stage.groups[engine.idGroup].items[i].check.visible === false &&
          stage.groups[engine.idGroup].items[i].block === false &&
          engine.id === stage.groups[engine.idGroup].items[i].id
        ) {
          stage.groups[engine.idGroup].items[i].isCorrect = true;
          stage.groups[engine.idGroup].items[i].time = new Date();
          stage.groups[engine.idGroup].items[i].toVisible = false;
          stage.groups[engine.idGroup].items[i].speed = stage.groups[engine.idGroup].items[i].check.speed;
          stage.groups[engine.idGroup].items[i].wait = stage.groups[engine.idGroup].items[i].check.waitStart;
          stage.groups[engine.idGroup].items[i].effect = 'hide';
        }
      }

      e.stopPropagation();
      return false;
    }

    if (bad === engine.pairedNumber) {
      for (let i in stage.groups[engine.idGroup].items) {
        if (
          stage.groups[engine.idGroup].items[i].check.visible === false &&
          stage.groups[engine.idGroup].items[i].block === false
        ) {
          stage.groups[engine.idGroup].items[i].check.wait = 0;
          stage.groups[engine.idGroup].items[i].check.visible = true;
          stage.groups[engine.idGroup].items[i].check._moved = true;
        }
      }

      e.stopPropagation();
      return false;
    }

    engine.check.visible = false;

    e.stopPropagation();
  }

  get pairedNumber() {
    return this._pairedNumber;
  }
}

cjsMemo.tick = function(stage) {
  for (let gr in stage.groups) {
    let checks = [];
    for (let i in stage.groups[gr].items) {
      if (
        ((stage.groups[gr].items[i].check.visible !== stage.groups[gr].items[i].check.toVisible &&
          stage.groups[gr].items[i].check.toVisible === false) ||
          (stage.groups[gr].items[i].check._moved === true && stage.groups[gr].items[i].check.toVisible === true)) &&
        stage.groups[gr].items[i].block === false
      ) {
        stage.groups[gr].items[i].check._moved = true;
        checks.push(stage.groups[gr].items[i].check);
      }
    }
    for (let i = 0; i < checks.length; i++) {
      if (cjsEffects[checks[i].effect].call(this, checks[i]) === false) {
        continue;
      }
      checks.splice(i, 1);
    }

    if (checks.length > 0) {
      blockMove = true;
      continue;
    }

    for (let i in stage.groups[gr].items) {
      if (
        stage.groups[gr].items[i].check.autoHide === true &&
        stage.groups[gr].items[i].isCorrect === true &&
        stage.groups[gr].items[i].container.visible === true
      ) {
        stage.groups[gr].items[i].check._moved = true;
        checks.push(stage.groups[gr].items[i]);
      }
    }
    for (let i = 0; i < checks.length; i++) {
      checks[i]._moved = true;
      if (cjsEffects[checks[i].effect].call(this, checks[i]) === false) {
        continue;
      }
      checks[i]._moved = false;
      checks.splice(i, 1);
    }

    if (checks.length > 0) {
      blockMove = true;
      continue;
    }

    let count = 0,
      pairedNumber = 0,
      autoHide;
    for (let i in stage.groups[gr].items) {
      if (stage.groups[gr].items[i].check.visible === false && stage.groups[gr].items[i].block === false) {
        if (stage.groups[gr].items[i].isCorrect === true) {
          stage.groups[gr].items[i].block = true;
          continue;
        }
        count++;
        pairedNumber = stage.groups[gr].items[i].pairedNumber;
        autoHide = stage.groups[gr].items[i].check.autoHide;
      }
    }

    if (count === pairedNumber && count > 0 && stage.removeInCorrects === true) {
      blockMove = true;

      for (let i in stage.groups[gr].items) {
        if (stage.groups[gr].items[i].check.visible === false && stage.groups[gr].items[i].block === false) {
          stage.groups[gr].items[i].check.wait = stage.groups[gr].items[i].check.waitStart;
          stage.groups[gr].items[i].check.visible = true;
          stage.groups[gr].items[i].check._moved = true;
        }
      }
      continue;
    }

    blockMove = false;
  }
};
